import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { GridColDef } from '@mui/x-data-grid-pro';
import { usePaycodesQuery } from './usePaycodesQuery';
import { usePaycodesTableState } from './usePaycodesTableState';

export const usePaycodesTable = () => {
    const { t } = useTranslation()
    const { rows, setRows, loading, setLoading, loadData } = usePaycodesQuery();
    const {
        contextMenu,
        setContextMenu,
        selectedRow,
        setSelectedRow,
        selected,
        setSelected,
        cleanSelected,
    } = usePaycodesTableState();

    const columns: GridColDef[] = useMemo(() => [
        {
            field: 'name',
            headerName: t('settings.paycodes.table.columns.name'),
            flex: 1,
        },
        {
            field: 'type',
            headerName: t('settings.paycodes.table.columns.type'),
            flex: 1,
        },
        {
            field: 'unit',
            headerName: t('settings.paycodes.table.columns.unit'),
            flex: 1,
        },
        {
            field: 'code_number',
            headerName: t('settings.paycodes.table.columns.code_number'),
            flex: 1,
        },
        {
            field: 'description',
            headerName: t('settings.paycodes.table.columns.description'),
            flex: 3,
        },
    ], [t]);

    const reloading = useCallback(() => {
        const permissions = JSON.parse(localStorage.getItem('permissions') || '[]') as string[];
        const canReadPaycodes = permissions.includes('timekeeper.GetPaycodes');

        if (canReadPaycodes) {
                loadData().finally(() => {
                    setContextMenu(null)
                    cleanSelected()
                })
        } else {
            setRows([])
            setLoading(false)
        }
    }, [cleanSelected, loadData, setContextMenu, setLoading, setRows]);

    return {
        rows,
        loading,
        loadData,
        reloading,
        selectedRow,
        setSelectedRow,
        contextMenu,
        setContextMenu,
        selected,
        setSelected,
        columns,
        cleanSelected
    };
}